import SettingsScreen from './SettingsScreen';
import PermissionsScreen from './PermissionsScreen';
import HowTo from './HowTo';

export {SettingsScreen, PermissionsScreen, HowTo};
